export default "__VITE_ASSET__DpednzWW__"